import { render, staticRenderFns } from "./Extra.vue?vue&type=template&id=c5ba7938&scoped=true&"
import script from "./Extra.vue?vue&type=script&lang=js&"
export * from "./Extra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba7938",
  null
  
)

export default component.exports